let watcher = null;

function report() {
  if (!watcher) {
    return;
  }
  const io = watcher.getIo();
  if (!io || !io.emit || !watcher.current) {
    return;
  }
  const current = watcher.current;
  const active = !!(current.open && document.visibilityState === 'visible' && document.hasFocus());
  io.emit('conversationView', {
    peerId: String(current.peerId || ''),
    active,
  });
}

export function watchConversation(getIo) {
  if (!watcher) {
    watcher = { getIo, current: null };
    document.addEventListener('visibilitychange', report);
    window.addEventListener('focus', report);
    window.addEventListener('blur', report);
  } else {
    watcher.getIo = getIo;
  }
  return { report };
}

export function setConversationView(peerId, open) {
  if (!watcher) {
    return;
  }
  if (!open && watcher.current && String(watcher.current.peerId) !== String(peerId)) {
    return;
  }
  watcher.current = { peerId, open: !!open };
  report();
}

export function chatOpenPath() {
  const routes = window.baglessNotificationRoutes || {};
  return routes.chatPath || '';
}
